import { ModalShare } from './ModalShare';

export type { TypeModalShareProps } from './types';
export default ModalShare;
